import { NavLink, Outlet } from "react-router-dom";
import { cn } from "@/utils/cn";

const exploreTabs = [
  { to: "/explore/collection", label: "Collection" },
  { to: "/explore/stored-trends", label: "Stored trends" },
];

export function AdminExplorePage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-xl font-bold tracking-tight sm:text-2xl">Explore</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Run collection pipelines and review trends saved across all topics.
        </p>
      </header>

      <nav
        aria-label="Explore sections"
        className="flex gap-1 overflow-x-auto border-b border-border"
      >
        {exploreTabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              cn(
                "shrink-0 border-b-2 px-3 py-2.5 text-sm font-medium transition-colors",
                isActive
                  ? "border-primary text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
